module.exports = __webpack_public_path__ + "img/icon1.8a53e6bb.png";